import { useTranslation } from "react-i18next";
import TaskList from "../common/TaskList";
import { useDispatch } from "../providers/DispatchProvider";
import { Button, Grid, Stack, Typography } from "@mui/material";
import { useNavigate } from "react-router";

export default function MobileRecentlyCompletedView() {
  const { t } = useTranslation();
  const { showLoading, completedTasks24H, completedTasks } = useDispatch();
  const navigate = useNavigate();

  return (
    <>
      <Grid item xs={12}>
        <Stack spacing={1}>
          <Typography variant="body" color="textSecondary">
            {completedTasks24H.length} {t("dispatch:recentlyCompleted:last24h")} ({completedTasks.length} {t("common:today")})
          </Typography>
          <TaskList
            tasks={completedTasks24H}
            showLoading={showLoading}
            emptyStateTitle={t("dispatch:recentlyCompleted:emptyStateTitle")}
            emptyStateDescription={t("dispatch:recentlyCompleted:emptyStateDescription")}
            cards
            slim
          />
        </Stack>
      </Grid>

      <Grid item xs={12}>
        <Stack alignItems="center" justifyContent="center" spacing={1}>
          <Typography variant="body2" color="textSecondary">
            {t("dispatch:recentlyCompleted:archive")}
          </Typography>
          <Button variant="contained" color="inherit" size="small" onClick={() => navigate("/tasks")}>
            {t("dispatch:recentlyCompleted:archiveButton")}
          </Button>
        </Stack>
      </Grid>
    </>
  );
}